import AntiFraudRecipientFlowPage from 'apps/auth/components/antifraud/AntiFraudRecipientFlowPage';
import AntiFraudRecipientOnlyMotion from 'apps/auth/components/antifraud/AntiFraudRecipientOnlyMotion';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import AntiFraudCheckSumCard from 'apps/auth/pages/antifraud/AntiFraudCheckSumCard';
import AntiFraudCvvCheck from 'apps/auth/pages/antifraud/AntiFraudCvvCheck';
import AntiFraudFieldsPage from 'apps/auth/pages/antifraud/AntiFraudFieldsPage';
import AntifraudGTAmlLevelInfoPage from 'apps/auth/pages/antifraud/AntifraudGTAmlLevelInfoPage';
import AntiFraudNotifyRecipientPage from 'apps/auth/pages/antifraud/AntiFraudNotifyRecipientPage';
import AntiFraudPepCheckPage from 'apps/auth/pages/antifraud/AntiFraudPepCheckPage';
import AntiFraudSourceOfIncomePage from 'apps/auth/pages/antifraud/AntiFraudSourceOfIncomePage';
import VerifyAddressPage from 'apps/auth/pages/antifraud/VerifyAddressPage';

const authAntiFraud = [
    {
        path: [
            '/auth/antifraud/purpose/transfer/:payId',
            '/auth/antifraud/relationship/and/splitting/:payId',
            '/auth/antifraud/recipient/relationship/:payId',
            '/auth/antifraud/additional/info/:payId',
            '/auth/antifraud/source/of/funds/:payId',
        ],
        component: AntiFraudFieldsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/antifraud/check/cvv/:payId',
        component: AntiFraudCvvCheck,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: '/auth/antifraud/check/sum/verification/:payId',
        component: AntiFraudCheckSumCard,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: '/auth/antifraud/check/source/of/income/:payId',
        component: AntiFraudSourceOfIncomePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: '/auth/antifraud/notify/recipient/:payId',
        component: AntiFraudNotifyRecipientPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: '/auth/antifraud/pep/:payId',
        component: AntiFraudPepCheckPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: '/auth/antifraud/update/address/:payId',
        component: VerifyAddressPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/antifraud/aml/level/docs/:payId',
        component: AntifraudGTAmlLevelInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/web/af/:uuid/motion',
        component: AntiFraudRecipientOnlyMotion,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: false,
        useSingleRoute: true,
        stateOptions: {
            registrationFlow: true,
            openChatInNoAuthZone: true,
        },
    },
    {
        path: '/web/af/:uuid',
        component: AntiFraudRecipientFlowPage,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: false,
        useSingleRoute: true,
        stateOptions: {
            registrationFlow: true,
            openChatInNoAuthZone: true,
        },
    },
];

export default authAntiFraud;
